"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DirectAnswerBlock() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="direct-answer-block" className="bg-background">
      <div className="w-full bg-[var(--card-foreground)] py-12 md:py-16 lg:py-20">
        <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-lg md:text-xl lg:text-2xl font-default text-[var(--color-logo)] leading-relaxed md:leading-relaxed lg:leading-relaxed font-medium text-center">
            Substation nameplate labeling is the permanent identification on substation and switchgear equipment — equipment nameplates, circuit and apparatus IDs, and high-voltage warning signs that must survive weather, UV, and decades of service. Evermark Industrial Solutions produces this identification in engraved stainless steel and anodized aluminum, matched to the utility's standard and the outdoor environment.
          </p>
        </div>
      </div>
    </section>;
}